<template lang="pug">
    div#rnd-mindcore-iris-view
        mainHeader
        div.box
            div.has-text-centered
                strong.title Iris
            hr
            div.columns
                div.column.is-narrow
                    youtube(:video-id="iris_yt_video_id")
                    //- img(:src="`${baseUrl}img/Iris.jpg`")
                div.column.has-text-justified
                    p Οι πυρκαγιές αποτελούν μάστιγα για την χώρα μας, κυρίως κατά τους καλοκαιρινούς μήνες, με μεγάλες δασικές εκτάσεις, και όχι μόνο, να καταλήγουν παρανάλωμα του πυρός. Τα αίτια ποικίλουν, όμως κοινή συνισταμένη όλων των περιπτώσεων είναι η αδυναμία της πρόληψης ή, έστω, του έγκαιρου εντοπισμού από τις αρμόδιες αρχές λόγω των αντικειμενικών δυσχερειών, όπως οι τεράστιες εκτάσεις που πρέπει να επιτηρηθούν. Η επιτήρηση από αέρος με συμβατικά μέσα (επανδρωμένα αεροσκάφη) είναι ενεργοβόρα και πολυδάπανη, άρα γρήγορα καθίσταται μη συμφέρουσα.
                    p Το σύστημα Iris φιλοδοξεί να συμβάλει στην επίλυση του μεγάλου αυτού προβλήματος. Αποτελείται από μη επανδρωμένο αεροσκάφος με δυνατότητα μεγάλης αυτονομίας, ικανού να περιπολεί, καλύπτοντας μεγάλες εκτάσεις και να αποστέλλει σε πραγματικό χρόνο εικόνα στην Πυροσβεστική Υπηρεσία για εκτίμηση ως προς την ύπαρξη ή μη κινδύνου. Έτσι, αυτή θα μπορεί να επέμβει άμεσα κατασβένοντας την εστία της πυρκαγιάς πριν προλάβει να εξαπλωθεί και να τεθεί εκτός ελέγχου.
                    p Η μεγάλη συνεισφορά του συστήματος αυτού είναι η δυνατότητα συνεχούς ελέγχου από αέρος όλων των επίφοβων περιοχών με πάρα πολύ χαμηλό κόστος και χωρίς την ανάγκη δέσμευσης ανθρώπινου δυναμικού. Επιπλέον, η δυνατότητα του συστήματος να απογειωθεί στατικά, χωρίς την ανάγκη χρήσης διαδρόμου, και το μικρό του βάρος το καθιστούν πολύ ευέλικτο για την μεταφορά και απογείωση του από οποιοδήποτε σημείο και όχι απαραιτήτως μόνο από την βάση επιχειρήσεων. Το σύστημα αποτελείται από επίγειο σταθμό ελέγχου (Ground Station), Drone (τύπου fixed-wing) και ασύρματη μετάδοση εικόνας (Video Link).
            
            
            br
            br
            //- div.columns
                div.column.is-5
                div.column
                    div.columns.is-centered
                        div.column.is-narrow.has-text-left
                            p.underline.subtitle.has-text-weight-semibold Το σύστημα αποτελείται από:
                            ul.a
                                li Επίγειο σταθμό ελέγχου (Ground Station)
                                li Drone (τύπου fixed-wing)
                                li Ασύρματη μετάδοση εικόνας (Video Link)
            
            br

            div.columns 
                div.column.has-text-justified.is-vcentered
                    br
                    p.underline.subtitle.has-text-weight-semibold Ground Station Gaea
                    p Το Gaea είναι σταθμός εδάφους για τον έλεγχο του συστήματος Iris. Ο χειρισμός γίνεται με joystick και μέσω συστήματος μετάδοσης εικόνας σε πραγματικό χρόνο. Επιπρόσθετα χρησιμοποιείται σύστημα τηλεμετρίας που δίνει πληροφορίες για τη θέση και τις γεωγραφικές συντεταγμένες που βρίσκεται και κινείται το σκάφος. Επίσης απεικονίζονται τα όργανα πτήσεως και άλλες κρίσιμες για την πτήση παράμετροι όπως πληροφορίες για την κατανάλωση ισχύος και τον χρόνο πτήσης. 
                    p Το Ground Station Gaea είναι τελείως αυτόνομο ενεργειακά και μπορεί να μεταφερθεί και να στηθεί σε οποιοδήποτε σημείο αφού μετατρέπεται σε βαλίτσα αλουμινίου και η μεταφορά του γίνεται πολύ εύκολη.

                    br
                    br
                    p.underline.subtitle.has-text-weight-semibold Προγραμματισμένες βελτιώσεις για το προσεχές μέλλον:
                        p Προσθήκη ενσωματωμένου συστήματος οπτικής αναγνώρισης μοτίβου (pattern recognition) ικανού να εντοπίσει και το παραμικρό ίχνος πυρκαγιάς στον ορίζοντα και να αποστείλει αυτόματα σε πραγματικό χρόνο ειδοποίηση με τις ακριβείς γεωγραφικές συντεταγμένες της εστίας της πυρκαγιάς στον αρμόδιο σταθμό της Πυροσβεστικής Υπηρεσίας.
                div.column.is-4
                    img(:src="`${baseUrl}img/DSC_0011.jpg`")
            br
            //- div.columns 
                div.column.is-12
                    youtube(:video-id="iris_yt_video_id")
                div.column.is-half

        Footer

</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import Footer from "@/components/Footer.vue";


export default {
  name: 'rnd-mindcore-nyx',
  components: {
    MainHeader,
    Footer
  },
  data: function () {
    return {
        baseUrl: process.env.BASE_URL,
        iris_yt_video_id: "TiJN5ESHnJk",
    };
  }
}
</script>

<style scoped>

/* p {
    padding-bottom: 0.2rem;
} */

.underline {
    text-decoration-line: underline;
    text-decoration-skip-ink: none;
}

ul.a {
    list-style-type: disc;
    list-style-position: outside;
}

.box {
    background-color: #E8E8E8;
}

hr {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;
}
</style>

